var render = function render(_c,_vm){return _c('v-row',[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12","sm":"6"}},[_vm._t("left",null,{"attributes":{
        exact: true,
        class: 'my-1',
        outlined: true,
        rounded: true,
        height: '40px',
        width: '100%',
        maxWidth: '332px'
      }})],2),_vm._v(" "),_c('v-col',{staticClass:"text-center",attrs:{"cols":"12","sm":"6"}},[_vm._t("right",null,{"attributes":{
        exact: true,
        class: 'my-1',
        rounded: true,
        height: '40px',
        width: '100%',
        maxWidth: '332px'
      }})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }